import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { marketDetailList } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "productionSalesDetails",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      exportdataloading: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      marketDetailList(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), this.paramsData), {}, {
        server_id: this.paramsData.server_id
      })).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;
          var list = _this.rawData.game_mark.indexOf('royalpirates') > -1 ? _this.serverList : _this.serverListYJ;

          _this.tableData.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataloading = true;
      marketDetailList(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), this.paramsData), {}, {
        server_id: this.paramsData.server_id,
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var list = _this2.rawData.game_mark.indexOf('royalpirates') > -1 ? _this2.serverList : _this2.serverListYJ;
          data.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
            item['cost1'] = "";
            item['obtain1'] = "";
            item['goods_list1'] = "";
            item.cost.forEach(function (a, index) {
              item['cost1'] += "".concat(a.name, ":").concat(a.num).concat(index != item.cost.length - 1 ? "," : "");
            });
            item.obtain.forEach(function (a, index) {
              item["obtain1"] += "".concat(a.name, ":").concat(a.num).concat(index != item.obtain.length - 1 ? "," : "");
            });
            item.goods_list.forEach(function (a, index) {
              item["goods_list1"] += "".concat(a.name, ":").concat(a.num).concat(index != item.goods_list.length - 1 ? "," : "");
            });
          });
          console.log("data===", data);
          var columns = [{
            label: _this2.$t('game'),
            prop: "game"
          }, {
            label: _this2.$t('platform'),
            prop: "platform"
          }, {
            label: _this2.$t('channel'),
            prop: "channel"
          }, {
            label: _this2.$t('pkg'),
            prop: "pkg"
          }, {
            label: _this2.$t('ip'),
            prop: "ip"
          }, {
            label: _this2.$t('serverId'),
            prop: "server_id"
          }, {
            label: _this2.$t('serverName'),
            prop: "server_name"
          }, {
            label: _this2.$t('roleId'),
            prop: "role_id_str"
          }, {
            label: _this2.$t('roleName'),
            prop: "role_name"
          }, {
            label: _this2.$t('userId'),
            prop: "user_id_str"
          },, {
            label: _this2.$t('level'),
            prop: "level"
          }, {
            label: _this2.$t('shopTypeLabel'),
            prop: "market_type"
          }, {
            label: _this2.$t('shopIdLabel'),
            prop: "market_id"
          }, {
            label: _this2.$t('costLabel'),
            prop: "cost1"
          }, {
            label: _this2.$t('obtainLabel'),
            prop: "obtain1"
          }, {
            label: _this2.$t('goodsListLabel'),
            prop: "goods_list1"
          }, {
            label: _this2.$t('extendedParams'),
            prop: "ext"
          }, {
            label: _this2.$t('time'),
            prop: "time"
          }];

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataloading = false;
      });
    }
  }
};